export default __webpack_public_path__ + "static/media/github-lg.23825057.png";